export default "__VITE_ASSET__BPjRtT9r__"